import React from 'react';
import {IconProps} from './IconProps';

export default function IconSortLetterAsc({className, height}: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      height={height}
    >
      <path
        d="M13.741 5.942L14.578 3.584H14.596L15.406 5.942H13.741ZM13.876 2L11.446 8.426H12.868L13.372 6.995H15.775L16.261 8.426H17.728L15.325 2H13.876Z"
        fill="currentColor"/>
      <path d="M11.707 16.884V18H17.125V16.812H13.588L17.035 12.69V11.574H11.977V12.762H15.154L11.707 16.884Z"
            fill="currentColor"/>
      <path
        d="M8.4426 6.51587C8.24734 6.71113 7.93076 6.71113 7.73549 6.51587L5.98743 4.7678V17.4723C5.98743 17.748 5.76434 17.9716 5.4887 17.9723L4.9887 17.9736C4.71206 17.9743 4.48743 17.7502 4.48743 17.4736V4.7678L2.73745 6.51777C2.54219 6.71304 2.22561 6.71304 2.03035 6.51777L1.6768 6.16422C1.48153 5.96896 1.48153 5.65238 1.6768 5.45712L5.06065 2.07326C5.15828 1.97563 5.31657 1.97563 5.4142 2.07326L8.79615 5.45521C8.99141 5.65047 8.99141 5.96705 8.79615 6.16232L8.4426 6.51587Z"
        fill="currentColor"/>
    </svg>
  );
}
